import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, ArrowUpRight, Sparkles } from "lucide-react";

export function EnquireSection() {
  const [instruments, setInstruments] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/instruments").then(({ data }) => setInstruments(data.instruments)).catch(() => {});
  }, []);

  const openFor = (name) => { setActive(name); setMessage(""); setOpen(true); };

  const send = async () => {
    setSending(true);
    try {
      await api.post("/enquiries", { instrument: active, message });
      toast.success("Enquiry sent — our team will be in touch.");
      setOpen(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSending(false); }
  };

  return (
    <div className="mt-6 bg-white rounded-xl border border-brand-line p-6 md:p-8 shadow-sm" data-testid="enquire-section">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="w-4 h-4 text-brand-gold" />
        <h2 className="font-serif text-2xl text-brand-green">Other estate planning</h2>
      </div>
      <p className="text-sm text-brand-muted mb-5">Interested in a more advanced arrangement? Enquire and an adviser will contact you.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {instruments.map((name) => (
          <button key={name} onClick={() => openFor(name)} data-testid={`enquire-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="group text-left rounded-lg border border-brand-line p-4 hover:border-brand-green hover:shadow-md transition-all duration-300 flex items-center justify-between gap-2">
            <span className="text-sm text-brand-ink">{name}</span>
            <ArrowUpRight className="w-4 h-4 text-brand-gold shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white" data-testid="enquire-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-brand-green">Enquire: {active}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-brand-muted">Add an optional note and we'll get back to you about the {active}.</p>
          <Textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={4} placeholder="Anything you'd like us to know?"
            className="bg-[#FCFBFA] border-brand-line" data-testid="enquire-message" />
          <Button onClick={send} disabled={sending} className="bg-brand-green hover:bg-brand-greenHover text-white" data-testid="enquire-send">
            {sending && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Send enquiry
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
